// reference: https://buildui.com/recipes/use-animated-text
import { animate } from 'motion/react';
import { useEffect, useState } from 'react';

const delimiter = ''; // or " " to split by word
const DEFAULT_DURATION = 2; // seconds

type UseAnimatedTextProps = {
  text: string;
  duration?: number;
};

export function useAnimatedText({ text, duration }: UseAnimatedTextProps) {
  const [cursor, setCursor] = useState(0);
  const [startingCursor, setStartingCursor] = useState(0);
  const [prevText, setPrevText] = useState(text);

  if (prevText !== text) {
    setPrevText(text);
    setStartingCursor(text.startsWith(prevText) ? cursor : 0);
  }

  useEffect(() => {
    const controls = animate(startingCursor, text.split(delimiter).length, {
      // Tweak the animation here
      duration: duration || DEFAULT_DURATION,
      ease: 'easeOut',
      onUpdate(latest) {
        setCursor(Math.floor(latest));
      },
    });

    return () => controls.stop();
  }, [startingCursor, text]);

  return text.split(delimiter).slice(0, cursor).join(delimiter);
}
